<aside id="admin-sidebar" class="admin-sidebar" [class.is-open]="layoutService.sidebarOpen" aria-label="Huvudmeny">
  <a class="admin-sidebar__brand" routerLink="/" (click)="layoutService.closeSidebar()">
    <img src="assets/images/shop.svg" alt="" height="43" width="47">
    <span class="admin-sidebar__title">Pubshop</span>
  </a>

  <nav class="admin-sidebar__nav">
    <a class="admin-sidebar__link" routerLink="/dashboard" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="layoutService.closeSidebar()">
      <i class="bi bi-house admin-sidebar__icon admin-sidebar__icon--home" aria-hidden="true"></i>
      Hem
    </a>
    <a class="admin-sidebar__link" routerLink="/products" routerLinkActive="active" (click)="layoutService.closeSidebar()">
      <i class="bi bi-journal-text admin-sidebar__icon admin-sidebar__icon--products" aria-hidden="true"></i>
      Publikationer
    </a>
    <a class="admin-sidebar__link" routerLink="/orders" routerLinkActive="active" (click)="layoutService.closeSidebar()">
      <i class="bi bi-cart admin-sidebar__icon admin-sidebar__icon--orders" aria-hidden="true"></i>
      Beställningar
    </a>
    <a class="admin-sidebar__link" routerLink="/reports" routerLinkActive="active" (click)="layoutService.closeSidebar()">
      <i class="bi bi-bar-chart admin-sidebar__icon admin-sidebar__icon--reports" aria-hidden="true"></i>
      Rapporter
    </a>
    <a class="admin-sidebar__link" routerLink="/settings" routerLinkActive="active" (click)="layoutService.closeSidebar()">
      <i class="bi bi-gear admin-sidebar__icon admin-sidebar__icon--settings" aria-hidden="true"></i>
      Inställningar
    </a>

  </nav>
</aside>
